module.exports = __webpack_public_path__ + "static/media/s4.3919cec6.png";